(function ($) {
	var bounds, infoWindow, map, marker;

	var isMobile = window.innerWidth < 640;

	var createContactServiceMap = function () {
		if (document.getElementById('contact-gmap-service')) {
			createContactServiceMapInit();
		}
	};

	var createContactServiceMapInit = async function () {
		// Declare to hold Team from REST endpoint
		let serviceCentersRaw;

		// Make the fetch call to the current environment
		const whereAmI = window.location.protocol + '//' + window.location.hostname;

		// Get the Centers
		const res = await fetch(whereAmI + '/wp-json/wp/v2/service-centers/?per_page=100');

		// JSON those Centers
		const centers = await res.json();

		// Only give us Centers that have Locations
		serviceCentersRaw = await centers.filter((center) => {
			return center.acf.location;
		});

		// Create object to hold processed Centers for use in in creating pins, infowindows, and polygons
		const serviceCenters = {};
		for (let center of serviceCentersRaw) {
			serviceCenters[center.slug] = {
				location: { lat: center.acf.location.lat, lng: center.acf.location.lng },
				territories: center.acf.territories,
				niceName: center.title.rendered,
				cardContent: center.acf.card_content,
				slug: center.slug,
			};
		}

		var zoomLevel = window.innerWidth < 1000 ? 4 : 5;

		map = new google.maps.Map(document.getElementById('contact-gmap-service'), {
			center: { lat: 39.5, lng: -98.35 },
			mapTypeControl: false,
			styles: [
				{
					featureType: 'administrative',
					elementType: 'labels.text.fill',
					stylers: [{ color: '#444444' }],
				},
				{
					featureType: 'administrative.province',
					elementType: 'geometry.stroke',
					stylers: [{ color: '#ff0000' }, { visibility: 'on' }, { weight: '2' }],
				},
				{
					featureType: 'administrative.country',
					elementType: 'geometry.stroke',
					stylers: [{ color: '#ff0000' }, { visibility: 'on' }, { weight: '2' }],
				},
				{ featureType: 'landscape', elementType: 'all', stylers: [{ color: '#f2f2f2' }] },
				{
					featureType: 'landscape.natural.terrain',
					elementType: 'all',
					stylers: [{ visibility: 'simplified' }],
				},
				{
					featureType: 'landscape.natural.terrain',
					elementType: 'geometry',
					stylers: [{ visibility: 'off' }],
				},
				{ featureType: 'poi', elementType: 'all', stylers: [{ visibility: 'off' }] },
				{
					featureType: 'road',
					elementType: 'all',
					stylers: [{ saturation: -100 }, { lightness: 45 }],
				},
				{
					featureType: 'road.highway',
					elementType: 'all',
					stylers: [{ visibility: 'simplified' }],
				},
				{
					featureType: 'road.highway',
					elementType: 'labels.icon',
					stylers: [{ visibility: 'simplified' }],
				},
				{
					featureType: 'road.arterial',
					elementType: 'labels.icon',
					stylers: [{ visibility: 'off' }],
				},
				{ featureType: 'transit', elementType: 'all', stylers: [{ visibility: 'off' }] },
				{
					featureType: 'water',
					elementType: 'all',
					stylers: [{ color: '#9bd3ea' }, { visibility: 'on' }],
				},
			],
			zoom: zoomLevel,
		});

		bounds = new google.maps.LatLngBounds();
		var allMarkers = [];
		var allInfoWindows = [];

		function addEventListenersToMarkers(marker, infoWindow) {
			google.maps.event.addListener(
				marker,
				'click',
				(function (marker) {
					return function () {
						allInfoWindows.forEach((window) => {
							window.close();
						});
						infoWindow.open(map, marker);
					};
				})(marker)
			);
			google.maps.event.addListener(
				marker,
				'closeclick',
				(function (marker) {
					return function () {
						map.fitBounds(bounds);
					};
				})(marker)
			);
		}

		// Iterate through each person
		const people = Object.keys(serviceCenters);
		people.forEach((center) => {
			var position = new google.maps.LatLng(
				serviceCenters[center].location.lat,
				serviceCenters[center].location.lng
			);

			bounds.extend(position);

			marker = new google.maps.Marker({
				icon: theme_directory + '/assets/pin-new.png',
				position: position,
				map: map,
				id: serviceCenters[center].slug,
			});

			infoWindow = new google.maps.InfoWindow({
				anchor: marker,
				content: `
				<div class="infowindow-container">
					<p class="infowindow-container__title">${serviceCenters[center].niceName}</p>
					<div class="infowindow-container__info">${serviceCenters[center].cardContent}</div>
				</dib>
				`,
				id: center,
				minWidth: 350,
				pixelOffset: new google.maps.Size(220, 120),
			});
			infoWindow.close();

			allMarkers.push(marker);
			allInfoWindows.push(infoWindow);

			if (isMobile) {
				map.fitBounds(bounds);
			}
		});

		// For scope to keep infowindows associated with the corresponding markers
		for (let i = 0; i < allMarkers.length; i++) {
			addEventListenersToMarkers(allMarkers[i], allInfoWindows[i]);
		}

		window.addEventListener('resize', function () {
			if (isMobile) {
				map.fitBounds(bounds);
			}
		});
	};

	$(window).load(function () {
		createContactServiceMap();
	});
})(jQuery);
